import { useMutation, useQueryClient } from '@tanstack/react-query'
import { MUTATION_REGISTRY } from '@/core/graphQL/registry'

// Builds a component-facing write hook from a registry entry. Cache invalidation
// is declared on the entry (`invalidates`) and runs on success, so components
// never orchestrate refetches themselves.
export function createMutationHook(registryKey) {
  const entry = MUTATION_REGISTRY[registryKey]
  if (!entry) {
    throw new Error(`[createMutationHook] Unknown mutation key: "${registryKey}"`)
  }

  const { service, invalidates = [] } = entry

  return function useGeneratedMutation(options = {}) {
    const queryClient = useQueryClient()
    const { onSuccess, ...restOptions } = options

    return useMutation({
      mutationFn: (params) => service(params),
      onSuccess: (data, variables, context) => {
        invalidates.forEach((queryKey) => queryClient.invalidateQueries({ queryKey }))
        onSuccess?.(data, variables, context)
      },
      ...restOptions,
    })
  }
}
